import styled from "styled-components";
import {JackpotBetWidgetGamesListContainerDefaultBox} from "./jackpot-bet-widget-games-list-container.default.box";


export const JackpotBetWidgetGamesListContainer777Box = styled(JackpotBetWidgetGamesListContainerDefaultBox)`
  background:transparent;
`;